// import Select from "./select";
import { observer } from "mobx-react-lite";
import SelectX from "./select-x";
import { FormInputProps } from "./types";

const ConfigSelect = observer((props: FormInputProps) => {
    const { config, watch } = props;

    return (<SelectX
        watch={watch}
        onChange={props.onChange}
        cssName={config.cssName}
        labelCssName="selectx-form-label"
        name={config.name}
        label={config.label}
        options={config.selectOptions ?? []}
        fieldOptions={config.fieldOptions} />);
});

export default ConfigSelect;